import { VuexOidcClientSettings } from 'vuex-oidc'
import { getRuntimeConfig } from './runtimeConfig'

export const oidcSettings: VuexOidcClientSettings = {
  authority: `https://login.microsoftonline.com/${getRuntimeConfig('VUE_APP_TENANT_ID', process.env.VUE_APP_TENANT_ID)}/v2.0`,
  clientId: getRuntimeConfig('VUE_APP_AUTH_CLIENT_ID', process.env.VUE_APP_AUTH_CLIENT_ID),
  redirectUri: getRuntimeConfig('VUE_APP_AUTH_REDIRECT_URI', process.env.VUE_APP_AUTH_REDIRECT_URI),
  responseType: 'code',
  scope: getRuntimeConfig('VUE_APP_AUTH_SCOPE', process.env.VUE_APP_AUTH_SCOPE),
  loadUserInfo: false,
  automaticSilentRenew: true,
  silentRedirectUri: getRuntimeConfig('VUE_APP_AUTH_REDIRECT_URI', process.env.VUE_APP_AUTH_REDIRECT_URI)
}
